import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { canEditGlobalCatalog } from '../../../features/auth/admin-capabilities';
import { useAuth } from '../../../features/auth/auth-context';
import { placeCategoryByIdOptions } from '../../../features/places/api/place-categories.queries';
import { DeletePlaceCategoryDialog } from '../../../features/places/components/delete-place-category-dialog';
import { PlaceCategoryForm } from '../../../features/places/components/place-category-form';
import { PageHeader } from '../../../shared/components/page-header';
import { SuperadminCatalogNotice } from '../../../shared/components/superadmin-catalog-notice';

export const Route = createFileRoute('/_authenticated/place-categories/$categoryId')({
  staticData: { breadcrumb: 'Редактирование' },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(placeCategoryByIdOptions(params.categoryId)),
  component: EditPlaceCategoryPage,
});

function EditPlaceCategoryPage() {
  const router = useRouter();
  const { categoryId } = Route.useParams();
  const { data: category } = useSuspenseQuery(placeCategoryByIdOptions(categoryId));
  const { adminRoles } = useAuth();
  const canEdit = canEditGlobalCatalog(adminRoles);

  return (
    <div>
      {!canEdit && <SuperadminCatalogNotice />}
      <PageHeader
        title={category.name}
        description={`slug: ${category.slug}`}
        actions={
          canEdit ? (
            <DeletePlaceCategoryDialog
              category={category}
              onDeleted={() => router.navigate({ to: '/place-categories' })}
            />
          ) : null
        }
      />
      <PlaceCategoryForm mode="edit" category={category} readOnly={!canEdit} />
    </div>
  );
}
